module.exports = __webpack_public_path__ + "bc3e276a5693dad4f8ad47a27afeba67.svg";